import { useEffect } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import FrfrAlienEditorjsRendererV1 from "./FrfrAlienEditorjsRendererV1";


// DEFAULT COMPONENT
const YourmapSectionOstaloV1Stuff = (props) => {
  console.log('YourmapSectionOstaloV1Stuff - props', props);
  const {
    current_smestaj_entity,
  } = props.appPack;
  const item = current_smestaj_entity;
  console.log();
  const title = item.smestaj_naslov;
  _zzyourmap_routing_browser_title_update(title);

  // const img_url_full = _zzyourmap_extract_smestaj_main_img_url(item);
  const img_url_full = item._main_img_url;
  const slide_img_src_arr = item._slide_img_src_arr;

  const style = {
    // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
    backgroundImage: 'url("' + img_url_full + '")',
  };

  // console.log('smestaj geo_uri', item.geo_uri);

  //
  const _special_blog_post_data = item._special_blog_post_data; // TODO
  let editorjs_renderable_data = _zzyourmap_extract_editorjs_renderable_data(_special_blog_post_data);
  //

  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-05rem"></div>
          <div className="yourmap__card yourmap__card--big-cover">
            <div className="yourmap__card__overlay-1" style={style}></div>
            <div className="yourmap__card__overlay-2"></div>
            <div className="yourmap__card-destinacija-content">
              <div className="yourmap__article__title-and-subtitle">
                <div className="uu-gap-standalone-1rem"></div>
                <h1>{item.smestaj_naslov}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-8px"></div>
          <div className="yourmap__slider__thumbnails">
            <div className="uu-vector uu-vector-row uu-vector--forced uu-gaps-p-025rem">
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
              <div className="xi">
                <div className="yourmap__slider__thumb"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-16px"></div>
          <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">
            <h2>{item.smestaj_naslov}</h2>
            <p>{item.smestaj_podnaslov}</p>
          </div>
        </div>
      </section>

      <section className="yourmap__section">
        <div className="inner">
          <div className="uu-gap-standalone-16px"></div>
          <div className="yourmap__card yourmap__card--normal uu-shadow-alien-fluent2-tile-shadow">
            {/*<UniSpinnerClassic />*/}
            <>
              <FrfrAlienEditorjsRendererV1 editorjs_renderable_data={editorjs_renderable_data} />
            </>
          </div>
        </div>
      </section>
    </>
  );
};

export default YourmapSectionOstaloV1Stuff;